import { activeAccessToken } from './AuthorizationHelpers'

export function authHeader() {
  const { token, exp } = activeAccessToken
  if (!token || (exp && Date.now() >= exp)) {
    return { Authorization: '', Public: false }
  }
  return { Authorization: `Bearer ${token}`, Public: false }
}

export function getShareTokenAuthHeader(token) {
  return { 'X-Share-Token': token, Public: true }
}
